import Swiper from 'swiper';
import { gsap } from 'gsap';
import { Pagination, EffectFade, Navigation } from 'swiper/modules';
import { animationTrigger, lg, md } from '../common';
import { markInteractedWith } from '../lib/swiper/markInteractedWith';

export function initPartnerSlider() {
  const parent = document.querySelector('.partner-slider');
  if (!parent) return;

  const swiperEl = parent.querySelector('.js-partner-slider__swiper .swiper');
  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  let swiper;

  function destroySwiper() {
    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }

  function initSmall() {
    destroySwiper();
    swiper = new Swiper(swiperEl, {
      modules: [Pagination],
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      slidesPerView: 1,
      breakpoints: {
        [md]: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
      },
    });
    markInteractedWith(swiper);
  }

  function initLarge() {
    destroySwiper();
    swiper = new Swiper(swiperEl, {
      modules: [Pagination, EffectFade, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      effect: 'fade',
      fadeEffect: { crossFade: true, speed: 1000 },
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  const mm = gsap.matchMedia();

  // Large and up: vertical + fade
  mm.add(`(min-width: ${lg}px)`, () => {
    initLarge();
    return () => destroySwiper();
  });

  // Below large: horizontal
  mm.add(`(max-width: ${lg - 1}px)`, () => {
    initSmall();
    return () => destroySwiper();
  });

  const slide = swiperEl.querySelector('.partner-slider__slide');
  const video = slide.querySelector('.partner-slider__video-wrap');
  const title = slide.querySelector('.partner-slider__title');
  const items = slide.querySelectorAll('.partner-slider__item');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: slide,
      start: animationTrigger,
      once: true,
      toggleActions: 'play none none none',
      // markers: true,
    },
  });
  tl.fromTo(
    video,
    { opacity: 0, scale: 0.8 },
    {
      opacity: 1,
      scale: 1,
      duration: 0.5,
      ease: 'power1.out',
      transformOrigin: 'center center',
    },
  );
  tl.fromTo(
    title,
    {
      clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
    },
    {
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      duration: 1.2,
      ease: 'power3.out',
      delay: 0,
    },
    '<',
  );
  tl.fromTo(
    items,
    { opacity: 0, y: 10 },
    {
      opacity: 1,
      y: 0,
      ease: 'power1.out',
      stagger: 0.1,
    },
    '<+=0.3',
  );
}
